import React from 'react'
import pdf from '../../../../static/politica_de_la_empresa.pdf'

function PoliticaDeEmpresa () {
  return (
    <iframe
      title='politicadeempresa'
      src={pdf}
      style={{ width: '100%', minHeight: '85vh', marginTop: '-2%' }}
    />

  )
}

export default PoliticaDeEmpresa
